import { topicsItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          全网剧迷正在热议的追剧话题，看看大家都在聊什么
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsItems.map((topic) => (
            <span
              key={topic.id}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="text-xs">{topic.heat.split(' ')[0]}</span>
              <span>{topic.name}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}